import { FC } from "react";
import styled from "styled-components";
import DatePicker, { registerLocale } from "react-datepicker";
import fi from "date-fns/locale/fi";
import i18n from "../../../i18n/config";
import { SearchFilterItem } from "./SearchFilterItem";
import { BasicInput } from "../../../styles/basicComponents";
import { FilterIcon, SearchIcon } from "../table/rowIcons";
import { useTheme } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

const SearchWrapper = styled.div`
    padding-bottom: 20px;
    display: flex;
`
const InputWrapper = styled.div`
    position: relative;
    display: inline-block;
`
const DatePickerWrapper = styled.div`
    display: inline-block;
`
const SearchInput = styled(BasicInput)`
    height: 30px;
    border: 2px solid ${(props) => props.theme.brandColor1};
    @media screen and (max-width: 400px) {
        width: 180px;
    }
`
const Select = styled.select`
    width: 55px;
    color: ${(props) => props.theme.brandColor1};
    background-color: ${(props) => props.theme.brandColor1};
    height: 30px;
    border-radius: 100px;
    padding-top: 2px;
    margin-left: 5px;
`

interface SearchProps {
    filter: string;
    filterParam: string;
    selectedDate?: Date;
    searchFilters: SearchFilterItem[];
    filterParamChange: (newFilterParam: string | Date) => void;
    filterChange: (newFilter: string) => void;
}

const Search:FC<SearchProps> = (props) => {
    const { t } = useCustomTranslation();
    const theme = useTheme();

    registerLocale("fi", fi);
    
    return(
        <SearchWrapper>
            <InputWrapper>
                {(props.filter === 'receivedStartDate' || props.filter === 'receivedEndDate') ? 
                    <DatePickerWrapper>
                        <label htmlFor="ReceivedDatePicker" />
                        <DatePicker id="ReceivedDatePicker" locale={i18n.language} calendarStartDay={1} dateFormat={'dd.MM.yyyy'} selected={props.selectedDate ? props.selectedDate : new Date()} onChange={(date: Date | null )=> props.filterParamChange(date ? date : '')} />
                    </DatePickerWrapper> :
                        <SearchInput theme={theme} aria-labelledby="searchInput" id="searchInput" type="text" value={props.filterParam} onChange={ (e) => props.filterParamChange(e.target.value)}/>
                }
                <SearchIcon theme={theme}/>
            </InputWrapper>
            <InputWrapper>
                <Select theme={theme} aria-labelledby="searchFilterSelect" id="searchFilterSelect" value={props.filter} onChange = {(e) => (props.filterChange(e.target.value))}>
                    {props.searchFilters.map((searchFilter, index) => (
                        <option key={index} value={searchFilter.filterName}>{t(searchFilter.filterLabel)}</option>))
                    }
                </Select>
                <FilterIcon />
            </InputWrapper>
        </SearchWrapper>
    )
}

export default Search;